import type { ComponentProps, FC } from 'react';
import { cn } from '../lib/utils';

/**
 * A stack of rows inside a menu surface. Items match the dropdown menu.
 * Pass `aria-labelledby` to tie it to a `ListLabel`, and `tabIndex={0}` when
 * it scrolls so keyboard users can reach the overflow.
 */
export const List: FC<ComponentProps<'ul'>> = ({ className, ...props }) => (
  <ul className={cn('flex flex-col', className)} {...props} />
);
